import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBxPlus = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M19 11H13V5H11V11H5V13H11V19H13V13H19V11Z",
		fill: "currentColor"
	})
});
export default SvgBxPlus;
